export default {
  login: "โปรดเข้าสู่ระบบเพื่อจะดำเนินการต่อ...",
  password_rule: "รหัสผ่านต้องประกอบด้วยตัวพิมพ์เล็ก/ใหญ่ และมีความยาวระหว่าง 6 ถึง 10 ตัวอักษร",
  nickname_rule:
    "คุณสามารถตั้งชื่อเล่นสำหรับการแสดงผลและเข้าสู่ระบบ (ตัวอักษรหรือตัวเลข 6-15 ตัว) โปรดทราบว่า คุณตั้งชื่อเล่นนี้ได้ครั้งเดียวเท่านั้น คุณไม่สามารถแก้ไขหรือยกเลิกชื่อเล่นนี้เมื่อตั้งค่าแล้ว",
  change_password_succeed: "เปลี่ยนรหัสผ่านสำเร็จ",
  add_secondary_succeed: "ตั้งชื่อเล่นสำเร็จ",
  succeed: "คุณได้ดำเนินการเรียบร้อยแล้ว!",
  failed: "คุณดำเนินการไม่สำเร็จ!",
  no_information_available: "ไม่มีข้อมูล",
  select_display_language: "เลือกภาษาที่คุณต้องการ",
  select_odds_type: "เลือกประเภทการแสดงผลราคาตามที่ต้องการ. ",
  select_page_type: "เลือกค่าแสดงผลบนหน้าจอของคุณ ทั้งตลาดวันนี้และตลาดของวันถัดไป. ",
  select_show_score_map: "เปิดใช้งานกระดานแสดงคะแนนโดยอัตโนมัติเมื่อมีการวางเดิมพัน. ",
  select_default_event_sorting: "เลือกเรียงตามลำดับการแสดงผลเกมส์ตามที่คุณต้องการ. ",
  select_market_type: "เลือกตลาดที่คุณต้องการ ",
  select_page_size: "เลือกขนาดหน้าเว็บเพจที่คุณต้องการ",
  change_sports_menu_order: "กรุณาลากกีฬาเพื่อเปลี่ยนแปลงคำสั่งที่ต้องการของเมนูกีฬา",
  view_outstanding_bets_in_bet_list: "ยอดเดิมพันค้างชำระอาจต้องใช้เวลาสักครู่เพื่อประมวลผล กรุณาไปที่ รายการวางเดิมพัน เพื่อดูยอดเดิมพันค้างชำระล่าสุดของคุณ",
  time_display_in_gmt_plus_8: "โปรดทราบว่าเวลาที่แสดงอยู่บนพื้นฐาน GMT +8 ชั่วโมง.",
  select_default_stake: "เปิดใช้งานระบบอัตโนมัติป้อนเดิมพันที่คุณกำหนดเอง เงินเดิมพันล่าสุดและจำนวนเงินเดิมพันสูงสุดหรือต่ำสุด.",
  bet_empty: "บิลเดิมพันของคุณว่างเปล่า กรุณาคลิกที่อัตราเดิมพันในตารางเพื่อเลือกการเดิมพัน",
  no_event: "ไม่มีการแข่งขันหรือเกมในขณะนี้ กรุณาเยี่ยมชมกิจกรรมกีฬาหรือเกมอื่น ๆ หรือกลับมาในภายหลัง",
  no_bets: "ไม่มีเดิมพันที่กำลังดำเนินการ",
  no_waiting: "ไม่มีเดิมพันที่รอการยอมรับ",
  no_void: "ไม่มีเดิมพันที่เป็นโมฆะ",
  odds_changed: "อัตราต่อรองเปลี่ยน รีเฟรชอัตราต่อรองใหม่หรือไม่",
  confirmation: "คุณยืนยันที่จะวางเดิมพันนี้หรือไม่?",
  olderversion: "ตรวจพบเวอร์ชันที่เก่ากว่าคลิกตกลงเพื่ออัพเดตหรือกด Ctrl-F5",
  gmt8: "โปรดทราบว่าเวลาที่แสดงอยู่บนพื้นฐาน GMT +8 ชั่วโมง.",
  confirm_bet: "ยืนยันการเดิมพันหรือไม่?",
  match_not_started: "การแข่งขันยังไม่เริ่ม",
  to: "to",

  login2: "ในการเข้าสู่ระบบและเข้าถึงเกมของเราคุณต้องลงทะเบียนบัญชีก่อน หากคุณมีบัญชีอยู่แล้วโปรดเข้าสู่ระบบต่อไป",

  days: "วัน",
  hours: "ชั่วโมง",
  mins: "นาที",
  secs: "วินาที",

  button_skip: "ข้ามการทัวร์",
  button_previous: "ก่อนหน้า",
  button_next: "ถัดไป",
  button_stop: "เสร็จสิ้น",
  button_continue: "ดำเนินการต่อ",
};
